import { withInstall } from '@ll-plus/utils'

import Signature from './src/signature.vue'

export const LlSignature = withInstall(Signature)
export default LlSignature
export * from './src/signature'

declare module 'vue' {
  export interface GlobalComponents {
    LlSignature: typeof Signature
  }
}
